
import React from 'react';
import Typography from "@mui/material/Typography";
import {PROJECT} from '../utils/constant';
import Container from '@mui/material/Container';
import image from "../assets/logo.png";

import Box from '@mui/material/Box';
import {Button} from "@mui/material";
import {signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import {auth} from "../services/firebase";
const provider = new GoogleAuthProvider();
const Login = () => {
    const handleLogin = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // Handle successful login
                console.log(result.user);
            })
            .catch((error) => {
                // Handle errors
                console.error(error);
            });
    };

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                // backgroundImage: `url(${background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                textAlign: 'center',
                color: 'white'
            }}
        >
            <Box sx={{ mb: 4 }}>
                <img src={image} alt="Logo" style={{ width: '150px' }} />
            </Box>
            <Typography variant="h4" sx={{ mb: 2 }}>
                {PROJECT.NAME}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={handleLogin}
                sx={{ mt: 2 }}
            >
                Login with Google
            </Button>
        </Container>
    );
};

export default Login;
